<template>
  <div id="about">
      <v-container>

        <span v-if="language==='RU'"><PageTitle :title="title_RU" /></span>
        <span v-if="language==='EN'"><PageTitle :title="title_EN" /></span>

          <v-layout row wrap>
              <v-flex xs12 sm4 class="white--text pr-3">
                <a :href="`/img/anna1.jpg`" data-fancybox="about" 
                                            data-type="image"              
                                            class="img-tumbnail pull-left" 
                                            width="100%">

                    <div class="thumb">
                      <img :src="`/img/anna1_thumb.jpg`" alt="Анна Братусь" width="100%" />
                    </div>
                </a>

                  <span v-if="language==='RU'"><p class="text-justify text-faded">{{ col1.RU.text }}</p></span> 
                  <span v-if="language==='EN'"><p class="text-justify text-faded">{{ col1.EN.text }}</p></span>   

              </v-flex>
              <v-flex xs12 sm4 class="white--text pr-3 text-justify text-faded">
                <a :href="`/img/anna3.jpg`" data-fancybox="about" 
                                            data-type="image"              
                                            class="img-tumbnail pull-left" 
                                            width="100%">

                    <div class="thumb">
                      <img :src="`/img/anna3_thumb.jpg`" alt="Анна Братусь" width="100%" />
                    </div>
                </a>

                  <span v-if="language==='RU'"><p class="text-justify text-faded">{{ col2.RU.text }}</p></span>
                  <span v-if="language==='EN'"><p class="text-justify text-faded">{{ col2.EN.text }}</p></span>

              </v-flex>
              <v-flex xs12 sm4 class="white--text text-justify text-faded">
                  <a :href="`/img/anna2.jpg`" data-fancybox="about" 
                                              data-type="image"              
                                              class="img-tumbnail pull-left" 
                                              width="100%">

                        <div class="thumb">
                          <img :src="`/img/anna2_thumb.jpg`" alt="Анна Братусь" width="100%" />
                        </div>
                    </a>

                  <span v-if="language==='RU'"><p class="text-justify text-faded">{{ col3.RU.text }}</p></span>
                  <span v-if="language==='EN'"><p class="text-justify text-faded">{{ col3.EN.text }}</p></span>

              </v-flex>
          </v-layout>        
      </v-container>
  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle'
  export default {
    name: 'About',
    components: { PageTitle },
    data() {
      return {
        language: '',
        title_RU: 'Биография',
        title_EN: 'Biography',
        col1: {
          pic: '',
          RU: {
            text: 'Анна Братусь родилась в Донецке. С раннего детства проявился музыкальный талант. В 1990 году семья переезжает в г. Черновцы. Там будущая певица оканчивает музыкальную школу по классу бандуры и в 1996 году поступает в Донецкое музучилище. И с тех пор вся дальнейшая творческая судьба связана с Донецком. Здесь Анна с отличием заканчивает Донецкую музыкальную академию им. С.С.Прокофьева, получив звание "лучший выпускник 2005 года", а затем и аспирантуру в классе профессора, народной артистки Украины Алины Коробко. С 2002 года является солисткой Донецкой филармонии. За время работы в филармонии Анной было подготовлено большое количество сольных программ, включающих в себя музыку различных жанров и эпох. Среди них - Перголези "Стабат матер" (партия сопрано), "Вечерняя серенада", "Французские акварели", "Благословите женщину", "Феерия весны", "Возвращение любви" и многие другие.'
          },
          EN: {
            text: 'Anna Bratus was born in the city of Donetsk in Ukraine. Her talent in musics manifested in the early childhood. In 1990 the family moved to Chernivtsi. The future singer completed there her studies in the music school and in 1996 entered the conservatory in Donetsk. Since then the whole onward artistic career is related with this city. Here Anna graduated with excellence from the Donetsk Music Academy named after S.S. Prokofiev, having received the title of "the best graduate of 2005", and continued there with the post-graduate studies in the class of Alina Korobko — the professor and the people\'s artist of Ukraine. Since 2002 Anna is a soloist in the Philharmonic Society, where she presented a large number of solo programs, containing the musics of different genres and ages.'
          }
        },
        col2: {
          pic: '',
          RU: {
            text: 'Работу в филармонии Анна успешно сочетает с многочисленными гастролями, как по Украине, так и за рубежом. Ее удивительный голос звучал в Австрии, Италии, Швейцарии, Японии, Испании и многих других странах мира. Сотрудничала с Венским симфоническим оркестром и музыкальным агентством "Brosartfolkmusik" (Италия). Принимала участие в таких известных музыкальных фестивалях, как "Соляная Симфония" (г. Соледар, Украина) и "Музыкальное лето" (г. Вена, Австрия). Принимала участие в записи СD дисков "Восточная песнь", "Благословите женщину" со струнным ансамблем "Ричеркар", а также в записях из цикла "Культурное наследие Донбасса". Работает с разными музыкальными коллективами Донеччины: симфоническим оркестром Донецкой филармонии (дирижер – заслуженный деятель искусств Украины Александр Долинский), камерным оркестром "Виола" (художественный руководитель - заслуженный артист Украины Олег Бахтиозин),'
          },
          EN: {
            text: 'Anna successfully combines her philarmonic carrier with numerous concert tours, as in Ukraine, so as abroad. Her amazing voice sounded in Austria, Italy, Switzerland, Japan, Spain and many other countries. Anna collaborated with the Vienna Symphony Orchestra and with the music agency "Brosartfolkmusik" (Italy). She participated in such well-known music festivals as the "Solyanaya Simfoniya" (the city of Soledar, Ukraine) and the "Musical summer" (the city of Vienna, Austria). Anna recorded several CD\'s with the music of Western European composers together with the string ensemble "Richerkar", arias of operettas and musicals together with the Academic Symphony Orchestra of the Donetsk Philharmonic Society, and participated as well in the recording of the musical serie named "The cultural Heritage of Donbass".'
          }
        },
        col3: {
          pic: '',
          RU: {
            text: 'ансамбль "Мелодия" (руководитель – заслуженный деятель искусств Владимир Вязовский), струнный ансамбль "Ричеркар" (руководитель - Валерия Путря) и другими. Репертуар певицы очень разнообразный – начиная от оперных арий, классических и старинных романсов до народных песен. Анна является лауреатом и дипломантом всеукраинских и международных конкурсов. Среди них - Международный конкурс молодых вокалистов им. А. Соловьяненко "Соловьиная ярмарка" (2004 год), Международный конкурс оперных певцов в Италии (2008 год). Лучший работник культуры года (2005 год). За значительный вклад в культурно-просветительское развитие Украины, существенные творческие достижения и многолетнюю плодотворную деятельность в январе 2013 года Анне Братусь присвоено звание Заслуженной артистки Украины.'
          },
          EN: {
            text: 'Anna works together with different music teams of the Donetsk region, such as the Academic Symphony Orchestra of the Donetsk State Philharmonic Society, the Chamber Orchestra "Viola", the ensemble "Melodiya", the string ensemble "Richerkar" and others. The singer\'s repertoire varies from Opera arias, classical and old songs to folk songs. Anna has become a winner or a laureate of numerous Ukrainian and international contests. Among them are the "Solovyinnaya Yarmarka" - the International contest of young vocalists named after A. Solovyanenko in 2004, the International contest of opera singers in Italy in 2008.'
          }
        }
      }
    },
    mounted(){
      if(localStorage.lang){
        this.language = localStorage.lang
      }
    }
  }
</script>
